import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/styles";
import Page from "../../components/Page/Page.Component";
import {
    Grid,
    CssBaseline,
    MenuItem,
    Button,
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl,
    TextField,
    Autocomplete,
    createFilterOptions
} from "@mui/material";
import { Box } from "@material-ui/core";
import { useParams } from "react-router";
import { RequestVendorService } from "src/services";
import { useTranslation } from "react-i18next";
import AlertService from "src/services/AlertService";
import { PageLoading } from "src/components";
import { userStorage } from "src/common/Storage";

const useStyles = makeStyles(() => ({
    root: {
        marginLeft: "3%",
        marginRight: "3%",
        marginTop: "2%",
    },
    Roundborder: {
        border: "0.5px outset #cfcfcf",
        borderRadius: "5px",
        marginBottom: "2%",
        backgroundColor: "white",
        paddingBottom: "2%"
    },
    head: {
        color: "#0009b7",
        fontWeight: "regular",
        marginBottom: "2%",
    },
    textarea: {
        resize: "both",
    }
}));

const dataInput = {};

function RequestVendorCreateScreen() {
    const [onLoading, setOnLoading] = useState(true);
    const { t, i18n } = useTranslation();
    const { id } = useParams();
    const classes = useStyles();
    const [userInfo, setUserInfo] = useState("");

    const [isReq, setisReq] = useState(false);

    const [isSelectRdo, setisSelectRdo] = useState(false);
    const [isSelectType, setisSelectType] = useState(true);
    const [isTypeRegister, setisTypeRegister] = useState(true);
    const [isOtherPrefixName, setisOtherPrefixName] = useState(false);
    const [isSubfixName, setisSubfixName] = useState(false);
    const [isSelectCountry, setisSelectCountry] = useState(true);
    const [isSelectProvince, setisSelectProvince] = useState(true);
    const [isSelectDistrict, setisSelectDistrict] = useState(true);
    const [isSelectSubDistrict, setisSelectSubDistrict] = useState(true);

    const [ddlTypeVendor, setddlTypeVendor] = useState("");
    const [rdoType, SetrdoType] = useState("1");
    const [txtcitizenId, SetcitizenId] = useState("");
    const [ddlTypeRegister, setddlTypeRegister] = useState("");
    const [ddlSuffix, setddlSuffix] = useState("");
    const [ddlPrefixName, setddlPrefixName] = useState("");
    const [txtOtherPrefixName, SettxtOtherPrefixName] = useState("");
    const [txtVendorNameTH, SettxtVendorNameTH] = useState("");
    const [txtVendorNameEN, SettxtVendorNameEN] = useState("");
    const [txtEmail, SettxtEmail] = useState("");
    const [txtTel, SettxtTel] = useState("");
    const [txtTel2, SettxtTel2] = useState("");
    const [txtMobile, SettxtMobile] = useState("");
    const [txtFax, SettxtFax] = useState("");
    const [txtFax2, SettxtFax2] = useState("");
    const [txtAddress, SettxtAddress] = useState("");
    const [txtRoad, SettxtRoad] = useState("");
    const [ddlCountry, SetddlCountry] = useState([]);
    const [ddlProvince, SetddlProvince] = useState("");
    const [ddlDistrict, SetddlDistrict] = useState("");
    const [ddlSubDistrict, SetddlSubDistrict] = useState("");
    const [ddlZip, SetddlZip] = useState("");

    const [ddlDataNameTitle, SetddlDataNameTitle] = useState([]);
    const [ddlDataTypeRegister, SetddlDataTypeRegister] = useState([]);
    const [ddlDataSuffix, SetddlDataSuffix] = useState([]);
    const [ddlDataCountry, SetddlDataCountry] = useState([]);
    const [ddlDataProvince, SetddlDataProvince] = useState([]);
    const [ddlDataDistrict, SetddlDataDistrict] = useState([]);
    const [ddlDataSubDistrict, SetddlDataSubDistrict] = useState([]);
    const [ddlDataZip, SetddlDataZip] = useState([]);

    const [isThailand, SetisThailand] = useState(true);

    const [reqNo, SetreqNo] = useState("");
    const [reqStatus, SetresStatus] = useState("");
    const [reqDate, SetreqDate] = useState("");
    const [EsgUserName, SetEsgUserName] = useState("");
    const [EsgPassWord, SetEsgPassWord] = useState("");
    const [isDupVatRegisNo, setIsDupVatRegisNo] = useState(false);

    const handleChangeTypeVendor = (event) => {
        setddlTypeVendor(event.target.value);
        setisSelectType(false);
        RequestVendorService.ddlTypeRegister(event.target.value).then((resp) => {
            SetddlDataTypeRegister(resp);
        });
    };

    const handleChangeTypeRegister = (event) => {
        setddlTypeRegister(event.target.value);
        setisOtherPrefixName(false)
        setisSubfixName(false)
        if (ddlTypeVendor !== "3") {
            setisTypeRegister(false);
        }
        RequestVendorService.ddlNameTitle(event.target.value).then((resp) => {
            SetddlDataNameTitle(resp);
        });
    };

    const handleChangenameTitle = (value) => {
        setddlPrefixName(value.target.value);
        setisOtherPrefixName(value.target.value === 25 || value.target.value === 41) // 25, 41 other
        if (ddlTypeVendor === 2 && (value.target.value !== 25 && value.target.value !== 41)) { // 25, 41 other
            setisSubfixName(true);
            RequestVendorService.ddlSuffix(value.target.value).then((resp) => {
                SetddlDataSuffix(resp);
            });
        }
    };
    const handleChangeSubfix = (value, country, event) => {
        setddlSuffix(value.target.value);
    };

    const handleChangeCountry = (newValue) => {
        if (!newValue) {
            SetddlCountry([]);
            SetddlDataProvince([]);

            SetddlDistrict([]);
            SetddlDataSubDistrict([]);
            SetddlDataZip([]);

            setisSelectCountry(true);
            setisSelectProvince(true);
            setisSelectDistrict(true);
            setisSelectSubDistrict(true);
            SetisThailand(true);

            SetddlProvince("");
            SetddlDistrict("");
            SetddlSubDistrict("");
            SetddlZip("");
        }
        else {
            if (newValue.value !== "TH") {
                SetddlDistrict([]);
                SetddlDataSubDistrict([]);
                SetddlDataZip([]);
            }
            SetisThailand(newValue.value === "TH")
            selectCountry(newValue);
        }
    };
    function selectCountry(newValue) {
        SetddlCountry(newValue);
        setisSelectCountry(false);
        setOnLoading(true);
        RequestVendorService.ddlProvinces(newValue.value || "").then((resp) => {
            SetddlDataProvince(resp);
        }).then(() => setOnLoading(false));
    }

    const handleChangeProvince = (event) => {
        SetddlProvince(event.target.value);
        setisSelectProvince(false);
        if (ddlDataProvince.length > 0) {
            setOnLoading(true);
            RequestVendorService.ddlDistrict(event.target.value).then((resp) => {
                SetddlDataDistrict(resp);
            }).then(() => setOnLoading(false));
        }
    };
    const handleChangeDistrict = (event) => {
        SetddlDistrict(event.target.value);
        setisSelectDistrict(false);
        if (isThailand) {
            setOnLoading(true);
            RequestVendorService.ddlSubDistrict(event.target.value).then((resp) => {
                SetddlDataSubDistrict(resp);
            }).then(() => setOnLoading(false));
        }
    };
    const handleChangeSubDistrict = (event) => {
        SetddlSubDistrict(event.target.value);
        setisSelectSubDistrict(false);
        if (isThailand) {
            setOnLoading(true);
            RequestVendorService.ddlZip(event.target.value).then((resp) => {
                SetddlDataZip(resp);
                if (resp.length === 1) {
                    SetddlZip(resp[0].postCode);
                }
            }).then(() => setOnLoading(false));
        }
    };
    const handleChangeZip = (event) => {
        SetddlZip(event.target.value);
    };

    const handleChangeRadio = (event) => {
        if (event.target.value === "1") {
            let thai = ddlDataCountry.find(x => x.value === "TH");
            selectCountry(thai);
        }
        else {
            SetddlCountry([]);
            SetddlDataProvince([]);
            SetddlDistrict([]);
            SetddlDataSubDistrict([]);
            SetddlDataZip([]);

            SetddlProvince("");
            SetddlDistrict("");
            SetddlSubDistrict("");
            SetddlZip("");

            setisSelectCountry(true);
        }
        SetrdoType(event.target.value);
        setisSelectRdo(false)
    };

    const handlecloseTeb = () => {
        window.close();
    }
    const alertService = () =>
    {
                AlertService.question({ html: 'ยืนยันการบันทึก' })
            .then((res) => {
                if (res.isConfirmed) {
                    validate();
                }
            });
        }
    const validate = () => {
        dataInput.rdoType = rdoType;
        dataInput.ddlTypeVendor = ddlTypeVendor;
        dataInput.txtcitizenId = txtcitizenId;
        dataInput.ddlPrefixName = ddlPrefixName;
        dataInput.txtVendorNameTH = txtVendorNameTH;
        dataInput.txtOtherPrefixName = txtOtherPrefixName;
        dataInput.ddlSuffix = ddlSuffix;
        dataInput.txtVendorNameEN = txtVendorNameEN;
        dataInput.txtEmail = txtEmail;
        dataInput.txtTel = txtTel;
        dataInput.txtTel2 = txtTel2;
        dataInput.txtMobile = txtMobile;
        dataInput.txtFax = txtFax;
        dataInput.txtFax2 = txtFax2;
        dataInput.txtAddress = txtAddress;
        dataInput.txtRoad = txtRoad;
        dataInput.ddlCountry = ddlCountry.value;
        dataInput.ddlProvince = ddlProvince;
        dataInput.ddlDistrict = ddlDistrict;
        dataInput.ddlSubDistrict = ddlSubDistrict;
        dataInput.ddlZip = ddlZip;
        dataInput.userAction = userInfo.userProfile.userName;

        if (!dataInput.rdoType) {
            AlertService.error({ html: 'กรุณาระบุการจดทะเบียนผู้ค้า' });
            return;
        }
        if (!dataInput.ddlTypeVendor) {
            AlertService.error({ html: 'กรุณาระบุการจดทะเบียนผู้ค้า' });
            return;
        }
        if (rdoType !== "2") {
            if (!dataInput.txtcitizenId || dataInput.txtcitizenId.length < 13) {
                AlertService.error({ html: 'กรุณาระบุเลขที่ประจำตัวผู้เสียภาษีให้ถูกต้อง' });
                return;
            }
            if (isDupVatRegisNo) {
                AlertService.error({ html: 'มีเลขที่ประจำตัวผู้เสียภาษีนี้อยู่ในระบบแล้ว กรุณาระบุเลขที่ประจำตัวผู้เสียภาษีใหม่' });
                return;
            }
            if (!dataInput.ddlPrefixName) {
                AlertService.error({ html: 'กรุณาระบุคำนำหน้าชื่อ' });
                return;
            }
            if (isOtherPrefixName && !dataInput.txtOtherPrefixName) {
                AlertService.error({ html: 'กรุณาระบุคำนำหน้าชื่อ' });
                return;
            }
            if (isSubfixName && !dataInput.ddlSuffix) {
                AlertService.error({ html: 'กรุณาระบุคำลงท้าย' });
                return;
            }
        }
        if (!dataInput.txtVendorNameTH) {
            AlertService.error({ html: 'กรุณาระบุชื่อผู้ค้า(TH)' });
            return;
        }
        if (!dataInput.txtEmail) {
            AlertService.error({ html: 'กรุณาระบุE-mail(ใช้ติดต่อกับ ปตท.)' });
            return;
        }
        if (!dataInput.txtTel) {
            AlertService.error({ html: 'กรุณาระบุเบอร์โทรศัพท์' });
            return;
        }
        if (!dataInput.txtMobile) {
            AlertService.error({ html: 'กรุณาระบุเบอร์โทรศัพท์มือถือ' });
            return;
        }
        if (!dataInput.txtAddress) {
            AlertService.error({ html: 'กรุณาระบุที่อยู่' });
            return;
        }
        if (!dataInput.ddlCountry) {
            AlertService.error({ html: 'กรุณาระบุประเทศ' });
            return;
        }
        if (!dataInput.ddlProvince) {
            AlertService.error({ html: 'กรุณาระบุจังหวัด' });
            return;
        }
        if (!dataInput.ddlDistrict) {
            AlertService.error({ html: 'กรุณาระบุอำเภอ/เขต' });
            return;
        }
        if (!dataInput.ddlSubDistrict) {
            AlertService.error({ html: 'กรุณาระบุตำบล/แขวง' });
            return;
        }
        if (!dataInput.ddlZip) {
            AlertService.error({ html: 'กรุณาระบุรหัสไปรษณีย์' });
            return;
        }

        setOnLoading(true)
        RequestVendorService.SaveReqData(dataInput).then((resp) => {
            if (resp) {
                if (resp.reqId == "true") {
                    AlertService.success({ html: 'บันทึกข้อมูลสำเร็จ' }).then(() => {
                        setisReq(true);
                        SetEsgUserName(resp.userName);
                        SetEsgPassWord(resp.passWord);
                        SetreqDate(resp.date);
                    });
                    // SetreqNo(resp.reqNo);
                    // SetresStatus("รออนุมัติ");
                    // SetreqDate(resp.date);
                }else{
                    AlertService.error({ html: 'บันทึกข้อมูลไม่สำเร็จ' });
                }
            }
            setOnLoading(false)
        }).then(() => {
            setOnLoading(false)
        })
            .catch((data) => {
                setOnLoading(false)
                AlertService.error({ html: 'error' });
            });
    };

    const onBlurCitizenId = (e) => {
        RequestVendorService.CheckVatRegistrationNoExist(txtcitizenId).then((resp) => {
            setIsDupVatRegisNo(resp);
        });
    }

    useEffect(() => {
        setUserInfo(userStorage.getUser() || {});
        setisReq(!!id)
        RequestVendorService.ddlCountry().then((resp) => {
            SetddlDataCountry(resp);
            selectCountry(resp.find(x => x.value === "TH"));
        }).then(() => setOnLoading(false))
            .catch(() => {
                setOnLoading(false)
            });

    }, []);

    return (
        <Page className={classes.root}>
            <PageLoading open={onLoading} />
            <CssBaseline>
                <div className={classes.head}>
                    <Grid
                        columns={20}
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignContent="center"
                        alignItems="center"
                    >
                        <Grid item xs={20}>
                            <item>
                                <h1>{t("vendorCreate.vendorInfo")}</h1>
                            </item>
                        </Grid>
                        <Grid item xs={20} >
                            <item style={{ display: "flex", float: "right" }}>
                                {isReq ? null :
                                    <box>
                                        <Button style={{ marginRight: "5px" }} size="small" variant="contained" color="success" onClick={() => validate()}>
                                            <h1 >{t("vendorCreate.btnSave")}</h1>
                                        </Button>
                                        <Button size="small" variant="contained" color="error" onClick={() => handlecloseTeb()}>
                                            <h1 >{t("vendorCreate.btnCancel")}</h1>
                                        </Button>
                                    </box>
                                }
                                {isReq ?
                                    <box>
                                        <Button size="small" variant="contained" color="grey" onClick={() => handlecloseTeb()}>
                                            <h1 >{t("vendorCreate.btnClose")}</h1>
                                        </Button>
                                    </box>
                                    : null
                                }

                            </item>
                        </Grid>
                    </Grid>
                </div>
            </CssBaseline>
            <Grid className={classes.Roundborder} container
                spacing={2}
                rowSpacing={2}
                direction="row"
                justifyContent="space-between"
                alignContent="center"
                alignItems="center">
                <Grid item xs={12} sx={{ ml: 2 }} justify="flex-end">
                    <item>
                        <h1 >{t("vendorCreate.vendorInfo")}</h1>
                    </item>
                </Grid>
                <Grid item xs={12} ></Grid>
                {isReq &&
                    <>
                        <Grid item xs={12} style={{ paddingLeft: "10%", backgroundColor: "#ccfdff", verticalAlign: "middle" }} justify="flex-end">
                            <item >
                                <h1>ข้อมูลคำขอ</h1>
                            </item>
                        </Grid>
                        <Grid item xs={3} sx={{ pl: 10 }} justifyItems="flex-end">
                            <item style={{ display: "flex", float: "right" }} >
                                User Name
                            </item>
                        </Grid>
                        <Grid item xs={9} sx={{ pl: 10 }} justifyItems="flex-end">
                            <item style={{ display: "flex", float: "left" }} >
                                <box style={{ fontWeight: "600" }}>{EsgUserName}</box>
                            </item>
                        </Grid>
                        <Grid item xs={3} sx={{ pl: 10 }} justifyItems="flex-end">
                            <item style={{ display: "flex", float: "right" }} >
                                Pass Word
                            </item>
                        </Grid>
                        <Grid item xs={9} sx={{ pl: 10 }} justifyItems="flex-end">
                            <item style={{ display: "flex", float: "left" }} >
                                <box style={{ fontWeight: "600" }}>{EsgPassWord}</box>
                            </item>
                        </Grid>
                        <Grid item xs={3} sx={{ pl: 10 }} justifyItems="flex-end">
                            <item style={{ display: "flex", float: "right" }} >
                                วันที่สร้าง
                            </item>
                        </Grid>
                        <Grid item xs={9} sx={{ pl: 10 }} justifyItems="flex-end">
                            <item style={{ display: "flex", float: "left" }} >
                                <box style={{ fontWeight: "600" }}>{reqDate}</box>
                            </item>
                        </Grid><Grid item xs={12} ></Grid>
                        <Grid item xs={12} ></Grid>
                    </>
                }

                <Grid item xs={12} style={{ paddingLeft: "10%", backgroundColor: "#ccfdff" }} justify="flex-end">
                    <item >
                        <h1>{t("vendorCreate.generalInfo")}</h1>
                    </item>
                </Grid>
                <Grid item xs={3} sx={{ pl: 10 }} justify="flex-end"></Grid>
                <Grid item xs={9} >
                    <item >
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            onChange={handleChangeRadio}
                            disabled={isReq}
                            defaultValue="1"
                        >
                            <FormControlLabel disabled={isReq} value="1" control={<Radio size="small" />} label={t("vendorCreate.domesticVendor")} />
                            <FormControlLabel disabled={isReq} value="2" control={<Radio size="small" />} label={t("vendorCreate.interVendor")} />
                        </RadioGroup>
                    </item>
                </Grid>
                <Grid item xs={3} sx={{ pl: 10 }} justifyItems="flex-end">
                    <item style={{ display: "flex", float: "right" }} >
                    {t("vendorCreate.vendorType")}<Box sx={{ color: "red" }}>*</Box>
                    </item>
                </Grid>
                <Grid item xs={7} >
                    <item >
                        <FormControl sx={{ width: "100%" }}>
                            <TextField
                                disabled={isReq || isSelectRdo}
                                select
                                id="idTypeVendor"
                                size="small"
                                style={{ backgroundColor: "white" }}
                                value={ddlTypeVendor}
                                label={t("vendorCreate.vendorType")}
                                onChange={handleChangeTypeVendor}
                            >
                                <MenuItem key={2} value={2} name={"นิติบุคคล"}>
                                {i18n.language === "th" ? "นิติบุคคล" : "Corporation"}
                                </MenuItem>
                                <MenuItem key={1} value={1} name={"บุคคลธรรมดา"}>
                                {i18n.language === "th" ? "บุคคลธรรมดา" : "Person"}
                                </MenuItem>
                                <MenuItem key={3} value={3} name={"อื่นๆ/ไม่มีเลขประจำตัวผู้เสียภาษี"}>
                                {i18n.language === "th" ? "อื่นๆ/ไม่มีเลขประจำตัวผู้เสียภาษี" : "Other"}
                                </MenuItem>

                            </TextField>
                        </FormControl>
                    </item>
                </Grid>
                <Grid item xs={2} ></Grid>
                {rdoType !== "2" &&
                    <>
                        <Grid item xs={3} sx={{ pl: 10 }} justifyContent="space-between">
                            <item style={{ display: "flex", float: "right" }} >
                            {t("vendorCreate.taxNumber")}<Box sx={{ color: "red" }}>*</Box>
                            </item>
                        </Grid>
                        <Grid item xs={4} >
                            <item >
                                <TextField
                                    size="small"
                                    onChange={(e) => SetcitizenId(e.target.value)}
                                    onBlur={onBlurCitizenId}
                                    style={{ backgroundColor: "white" }}
                                    fullWidth
                                    id="outlined-search"
                                    label={t("vendorCreate.taxNumber")}
                                    inputProps={{ className: classes.textarea, maxLength: 13, autoComplete: 'off' }}
                                    disabled={isReq}
                                    error={isDupVatRegisNo}
                                    helperText={isDupVatRegisNo && 'มีเลขที่ประจำตัวผู้เสียภาษีนี้อยู่ในระบบแล้ว กรุณาระบุเลขที่ประจำตัวผู้เสียภาษีใหม่'}
                                />
                            </item>
                        </Grid>
                        <Grid item xs={5} ></Grid>
                        <Grid item xs={3} sx={{ pl: 10 }} justifyContent="space-between">
                            <item style={{ display: "flex", float: "right" }} >
                            {t("vendorCreate.regisType")}<Box sx={{ color: "red" }}>*</Box>
                            </item>
                        </Grid>
                        <Grid item xs={4} >
                            <item >
                                <FormControl sx={{ width: "100%" }}>
                                    <TextField
                                        disabled={isReq || isSelectType}
                                        select
                                        id="idTypeVendor"
                                        size="small"
                                        style={{ backgroundColor: "white" }}
                                        value={ddlTypeRegister}
                                        label={t("vendorCreate.regisType")}
                                        onChange={handleChangeTypeRegister}
                                    >
                                        {ddlDataTypeRegister.map((option) => (
                                            <MenuItem key={option.regisTypeID} value={option.regisTypeID} name={option.regisTypeName}>
                                                {i18n.language === "th" ? option.regisTypeName : option.regisTypeNameEN}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </FormControl>
                            </item>
                        </Grid>
                        <Grid item xs={5} ></Grid>
                        <Grid item xs={3} sx={{ pl: 10 }} justifyContent="space-between">
                            <item style={{ display: "flex", float: "right" }} >
                            {t("vendorCreate.title")}<Box sx={{ color: "red" }}>*</Box>
                            </item>
                        </Grid>
                        <Grid item xs={4} >
                            <item >
                                <FormControl sx={{ width: "100%" }}>
                                    <TextField
                                        disabled={isReq || isTypeRegister}
                                        select
                                        id="idTypeVendor"
                                        size="small"
                                        style={{ backgroundColor: "white" }}
                                        value={ddlPrefixName}
                                        label={t("vendorCreate.title")}
                                        onChange={handleChangenameTitle}
                                    >
                                        {ddlDataNameTitle.map((option) => (
                                            <MenuItem key={option.nameTitleID} value={option.nameTitleID} name={option.isOther + '|' + option.isSuffix}>
                                                {i18n.language === "th" ? option.nameTitleTH : option.nameTitleEN}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </FormControl>
                            </item>
                        </Grid>
                        <Grid item xs={5} ></Grid>
                    </>
                }
                {isOtherPrefixName &&
                    <>
                        <Grid item xs={3} sx={{ pl: 10 }} justifyContent="space-between">
                            <item style={{ display: "flex", float: "right" }} >
                                ระบุคำนำหน้า<Box sx={{ color: "red" }}>*</Box>
                            </item>
                        </Grid>
                        <Grid item xs={4} >
                            <item >
                                <TextField
                                    disabled={isReq}
                                    size="small"
                                    onChange={(e) => SettxtOtherPrefixName(e.target.value)}
                                    style={{ backgroundColor: "white" }}
                                    fullWidth
                                    id="outlined-search"
                                    label="ใส่คำนำหน้าชื่อ"
                                    type="search"
                                    inputProps={{ className: classes.textarea, autoComplete: 'off' }}
                                />
                            </item>
                        </Grid>
                        <Grid item xs={5} ></Grid>
                    </>
                }

                <Grid item xs={3} sx={{ pl: 10 }} justifyContent="space-between">
                    <item style={{ display: "flex", float: "right" }} >
                    {t("vendorCreate.vendorName")} {rdoType !== "2" && "(TH)"}<Box sx={{ color: "red" }}>*</Box>
                    </item>
                </Grid>
                <Grid item xs={7} >
                    <item >
                        <TextField
                            disabled={isReq}
                            size="small"
                            onChange={(e) => {
                                SettxtVendorNameTH(e.target.value);
                                if (rdoType === "2") {
                                    SettxtVendorNameEN(e.target.value);
                                }
                            }}
                            style={{ backgroundColor: "white" }}
                            fullWidth
                            id="outlined-search"
                            label={t("vendorCreate.vendorName")}
                            type="search"
                            inputProps={{ className: classes.textarea, autoComplete: 'off' }}
                        />
                    </item>
                </Grid>
                <Grid item xs={2} ></Grid>
                {isSubfixName &&
                    <>
                        <Grid item xs={3} sx={{ pl: 10 }} justifyContent="space-between">
                            <item style={{ display: "flex", float: "right" }} >
                                คำลงท้าย<Box sx={{ color: "red" }}>*</Box>
                            </item>
                        </Grid>
                        <Grid item xs={4} >
                            <item >
                                <FormControl sx={{ width: "100%" }}>
                                    <TextField
                                        disabled={isReq || isSelectType}
                                        select
                                        id="idTypeVendor"
                                        size="small"
                                        style={{ backgroundColor: "white" }}
                                        value={ddlSuffix}
                                        label="คำลงท้าย"
                                        onChange={handleChangeSubfix}
                                    >
                                        {ddlDataSuffix.map((option) => (
                                            <MenuItem key={option.lastNameTypeID} value={option.lastNameTypeID} name={option.lastNameType}>
                                                {option.lastNameType}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </FormControl>
                            </item>
                        </Grid>
                        <Grid item xs={5} ></Grid>
                    </>
                }
                {rdoType !== "2" &&
                    <>
                        <Grid item xs={3} sx={{ pl: 10 }} justifyContent="space-between">
                            <item style={{ display: "flex", float: "right" }} >
                            {t("vendorCreate.vendorName")} (EN)
                            </item>
                        </Grid>
                        <Grid item xs={7} >
                            <item >
                                <TextField
                                    size="small"
                                    disabled={isReq}
                                    onChange={(e) => SettxtVendorNameEN(e.target.value)}
                                    style={{ backgroundColor: "white" }}
                                    fullWidth
                                    id="outlined-search"
                                    label=""
                                    type="search"
                                    inputProps={{ className: classes.textarea, autoComplete: 'off' }}
                                />
                            </item>
                        </Grid>
                        <Grid item xs={2} ></Grid>
                    </>
                }
                <Grid item xs={3} sx={{ pl: 10 }} justifyContent="space-between">
                    <item style={{ display: "flex", float: "right" }} >
                    {t("vendorCreate.email")}<Box sx={{ color: "red" }}>*</Box>
                    </item>
                </Grid>
                <Grid item xs={7} >
                    <item >
                        <TextField
                            size="small"
                            disabled={isReq}
                            onChange={(e) => SettxtEmail(e.target.value)}
                            style={{ backgroundColor: "white" }}
                            fullWidth
                            id="outlined-search"
                            label="E-mail"
                            type="search"
                            inputProps={{ className: classes.textarea, autoComplete: 'off' }}
                        />
                    </item>
                </Grid>
                <Grid item xs={2} ></Grid>
                <Grid item xs={3} sx={{ pl: 10 }} justifyContent="space-between">
                    <item style={{ display: "flex", float: "right" }} >
                    {t("vendorCreate.phoneNo")}<Box sx={{ color: "red" }}>*</Box>
                    </item>
                </Grid>
                <Grid item xs={4} >
                    <item >
                        <TextField
                            size="small"
                            disabled={isReq}
                            onChange={(e) => SettxtTel(e.target.value)}
                            style={{ backgroundColor: "white" }}
                            fullWidth
                            id="outlined-search"
                            label={t("vendorCreate.phoneNo")}
                            type="search"
                            inputProps={{ className: classes.textarea, autoComplete: 'off' }}
                        />
                    </item>
                </Grid>
                <Grid item xs={1} >
                    <item style={{ display: "flex", float: "right" }} >
                    {t("vendorCreate.ext")}
                    </item>
                </Grid>
                <Grid item xs={2} >
                    <item >
                        <TextField
                            size="small"
                            disabled={isReq}
                            onChange={(e) => SettxtTel2(e.target.value)}
                            style={{ backgroundColor: "white" }}
                            fullWidth
                            id="outlined-search"
                            label={t("vendorCreate.ext")}
                            type="search"
                            inputProps={{ className: classes.textarea, autoComplete: 'off' }}
                        />
                    </item>
                </Grid>
                <Grid item xs={2} ></Grid>
                <Grid item xs={3} sx={{ pl: 10 }} justifyContent="space-between">
                    <item style={{ display: "flex", float: "right" }} >
                    {t("vendorCreate.mobileNo")}<Box sx={{ color: "red" }}>*</Box>
                    </item>
                </Grid>
                <Grid item xs={4} >
                    <item >
                        <TextField
                            size="small"
                            disabled={isReq}
                            onChange={(e) => SettxtMobile(e.target.value)}
                            style={{ backgroundColor: "white" }}
                            fullWidth
                            id="outlined-search"
                            label={t("vendorCreate.mobileNo")}
                            type="search"
                            inputProps={{ className: classes.textarea, autoComplete: 'off' }}
                        />
                    </item>
                </Grid>
                <Grid item xs={5} ></Grid>
                <Grid item xs={3} sx={{ pl: 10 }} justifyContent="space-between">
                    <item style={{ display: "flex", float: "right" }} >
                    {t("vendorCreate.faxNo")}
                    </item>
                </Grid>
                <Grid item xs={4} >
                    <item >
                        <TextField
                            size="small"
                            disabled={isReq}
                            onChange={(e) => SettxtFax(e.target.value)}
                            style={{ backgroundColor: "white" }}
                            fullWidth
                            id="outlined-search"
                            label={t("vendorCreate.faxNo")}
                            type="search"
                            inputProps={{ className: classes.textarea, autoComplete: 'off' }}
                        />
                    </item>
                </Grid>
                <Grid item xs={1} >
                    <item style={{ display: "flex", float: "right" }} >
                    {t("vendorCreate.ext")}
                    </item>
                </Grid>
                <Grid item xs={2} >
                    <item >
                        <TextField
                            size="small"
                            disabled={isReq}
                            onChange={(e) => SettxtFax2(e.target.value)}
                            style={{ backgroundColor: "white" }}
                            fullWidth
                            id="outlined-search"
                            label={t("vendorCreate.ext")}
                            type="search"
                            inputProps={{ className: classes.textarea, autoComplete: 'off' }}
                        />
                    </item>
                </Grid>
                <Grid item xs={2} ></Grid>
                <Grid item xs={12} ></Grid>
                <Grid item xs={12} ></Grid>
                <Grid item xs={12} backgroundColor="#ccfdff" style={{ paddingLeft: "10%" }} >
                    <item >
                        <h1>{t("vendorCreate.address")}</h1>
                    </item>
                </Grid>
                <Grid item xs={3} sx={{ pl: 10 }} justifyContent="space-between">
                    <item style={{ display: "flex", float: "right" }} >
                    {t("vendorCreate.address")}<Box sx={{ color: "red" }}>*</Box>
                    </item>
                </Grid>
                <Grid item xs={7} >
                    <item >
                        <TextField
                            size="small"
                            disabled={isReq}
                            onChange={(e) => SettxtAddress(e.target.value)}
                            style={{ backgroundColor: "white" }}
                            fullWidth
                            id="outlined-search"
                            label={t("vendorCreate.address")}
                            type="search"
                            inputProps={{ className: classes.textarea, autoComplete: 'off' }}
                        />
                    </item>
                </Grid>
                <Grid item xs={2} ></Grid>
                <Grid item xs={3} sx={{ pl: 10 }} justifyContent="space-between">
                    <item style={{ display: "flex", float: "right" }} >
                    {t("vendorCreate.road")}
                    </item>
                </Grid>
                <Grid item xs={7} >
                    <item >
                        <TextField
                            size="small"
                            disabled={isReq}
                            onChange={(e) => SettxtRoad(e.target.value)}
                            style={{ backgroundColor: "white" }}
                            fullWidth
                            id="outlined-search"
                            label={t("vendorCreate.road")}
                            type="search"
                            inputProps={{ className: classes.textarea, autoComplete: 'off' }}
                        />
                    </item>
                </Grid>
                <Grid item xs={2} ></Grid>
                <Grid item xs={3} sx={{ pl: 10 }} justifyContent="space-between">
                    <item style={{ display: "flex", float: "right" }} >
                    {t("vendorCreate.country")}<Box sx={{ color: "red" }}>*</Box>
                    </item>
                </Grid>
                <Grid item xs={4} >
                    <item >
                        <FormControl sx={{ width: "100%" }}>
                            <Autocomplete
                                disabled={isReq}
                                id="idCountry"
                                size="small"
                                options={ddlDataCountry}
                                value={ddlCountry}
                                onChange={(event, newValue) => {
                                    handleChangeCountry(newValue);
                                }}
                                getOptionLabel={(option) => option.label || ""}
                                isOptionEqualToValue={(option, value) =>
                                    option.value === value.value
                                }
                                renderInput={(params) => <TextField size="small" {...params} label={t("vendorCreate.country")} />}
                                style={{ backgroundColor: "white", paddingTop: "10px" }}
                            />
                        </FormControl>
                    </item>
                </Grid>
                <Grid item xs={1} >
                    <item style={{ display: "flex", float: "right" }} >
                    {t("vendorCreate.province")}<Box sx={{ color: "red" }}>*</Box>
                    </item>
                </Grid>
                <Grid item xs={2} >
                    <item >
                        <FormControl sx={{ width: "100%" }}>
                            {ddlDataProvince.length > 0 ? <TextField
                                disabled={isReq || isSelectCountry}
                                select
                                id="idTypeVendor"
                                size="small"
                                style={{ backgroundColor: "white" }}
                                value={ddlProvince}
                                label={t("vendorCreate.province")}
                                onChange={handleChangeProvince}
                            >
                                {ddlDataProvince.map((option) => (
                                    <MenuItem key={option.provinceCode} value={option.provinceCode} name={option.provinceNameTH}>
                                        {option.provinceNameTH}
                                    </MenuItem>
                                ))}
                            </TextField>
                                :
                                <TextField
                                    size="small"
                                    disabled={isReq}
                                    onChange={handleChangeProvince}
                                    style={{ backgroundColor: "white" }}
                                    value={ddlProvince}
                                    fullWidth
                                    id="outlined-search"
                                    label={t("vendorCreate.province")}
                                    type="search"
                                    inputProps={{ className: classes.textarea, autoComplete: 'off' }}
                                />
                            }
                        </FormControl>
                    </item>
                </Grid>
                <Grid item xs={2} ></Grid>
                <Grid item xs={3} sx={{ pl: 10 }} justifyContent="space-between">
                    <item style={{ display: "flex", float: "right" }} >
                    {t("vendorCreate.districe")}<Box sx={{ color: "red" }}>*</Box>
                    </item>
                </Grid>
                {isThailand ?
                    <Grid item xs={4} >
                        <item >
                            <FormControl sx={{ width: "100%" }}>
                                <TextField
                                    disabled={isReq || isSelectProvince}
                                    select
                                    id="idTypeVendor"
                                    size="small"
                                    style={{ backgroundColor: "white" }}
                                    value={ddlDistrict}
                                    label={t("vendorCreate.districe")}
                                    onChange={handleChangeDistrict}
                                >
                                    {ddlDataDistrict.map((option) => (
                                        <MenuItem key={option.districtNameTH} value={option.districtCode} name={option.districtNameTH}>
                                            {option.districtNameTH}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </FormControl>
                        </item>
                    </Grid>
                    :
                    <Grid item xs={4} >
                        <item >
                            <TextField
                                size="small"
                                disabled={isReq}
                                onChange={handleChangeDistrict}
                                style={{ backgroundColor: "white" }}
                                value={ddlDistrict}
                                fullWidth
                                id="outlined-search"
                                label="อำเภอ"
                                type="search"
                                inputProps={{ className: classes.textarea, autoComplete: 'off' }}
                            />
                        </item>
                    </Grid>
                }

                <Grid item xs={1} >
                    <item style={{ display: "flex", float: "right" }} >
                    {t("vendorCreate.subDistrice")}<Box sx={{ color: "red" }}>*</Box>
                    </item>
                </Grid>
                {isThailand ?
                    <Grid item xs={2} >
                        <item >
                            <FormControl sx={{ width: "100%" }}>
                                <TextField
                                    disabled={isReq || isSelectDistrict}
                                    select
                                    id="idTypeVendor"
                                    size="small"
                                    style={{ backgroundColor: "white" }}
                                    value={ddlSubDistrict}
                                    label={t("vendorCreate.subDistrice")}
                                    onChange={handleChangeSubDistrict}
                                >
                                    {ddlDataSubDistrict.map((option) => (
                                        <MenuItem key={option.subdistrictNameTH} value={option.subdistrictCode} name={option.subdistrictNameTH}>
                                            {option.subdistrictNameTH}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </FormControl>
                        </item>
                    </Grid>
                    :
                    <Grid item xs={2} >
                        <item >
                            <TextField
                                size="small"
                                disabled={isReq}
                                onChange={handleChangeSubDistrict}
                                style={{ backgroundColor: "white" }}
                                value={ddlSubDistrict}
                                fullWidth
                                id="outlined-search"
                                label={t("vendorCreate.subDistrice")}
                                type="search"
                                inputProps={{ className: classes.textarea, autoComplete: 'off' }}
                            />
                        </item>
                    </Grid>
                }
                <Grid item xs={2} ></Grid>
                <Grid item xs={3} sx={{ pl: 10 }} justifyContent="space-between">
                    <item style={{ display: "flex", float: "right" }} >
                    {t("vendorCreate.postCode")}<Box sx={{ color: "red" }}>*</Box>
                    </item>
                </Grid>
                {isThailand ?
                    <Grid item xs={4} >
                        <item >
                            <FormControl sx={{ width: "100%" }}>
                                <TextField
                                    disabled={isReq || isSelectSubDistrict}
                                    select
                                    id="idTypeVendor"
                                    size="small"
                                    style={{ backgroundColor: "white" }}
                                    value={ddlZip}
                                    label={t("vendorCreate.postCode")}
                                    onChange={handleChangeZip}
                                >
                                    {ddlDataZip.map((option) => (
                                        <MenuItem key={option.postCode} value={option.postCode} name={option.postCode}>
                                            {option.postCode}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </FormControl>
                        </item>
                    </Grid>
                    :
                    <Grid item xs={4} >
                        <item >
                            <TextField
                                size="small"
                                disabled={isReq}
                                onChange={handleChangeZip}
                                style={{ backgroundColor: "white" }}
                                value={ddlZip}
                                fullWidth
                                id="outlined-search"
                                label={t("vendorCreate.postCode")}
                                type="search"
                                inputProps={{ className: classes.textarea, autoComplete: 'off' }}
                            />
                        </item>
                    </Grid>
                }

                <Grid item xs={5} ></Grid>
            </Grid>
        </Page>
    );
}

export default RequestVendorCreateScreen;